// node_modules
import React from "react";

// styles
import * as styles from "./Footer.module.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className={styles.footer}>
      © {currentYear} All Rights Reserved, 1FIIT Technology
    </div>
  );
};

export default Footer;
